import React from "react";
import { FaFacebook, FaTwitter, FaLinkedin, FaYoutube, FaInstagram, FaX } from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from '../../elements/Agivant-White-Logo.png';
import linkedIn from '../../elements/LinkedIn-Button-01.png';

const Footer = () => {
  return (
    <footer className="items-center px-[15px] py-[15px] bg-[#2c3045] border-t border-[#dddddd]">
      <div className="flex flex-row justify-between ">
        <div className="flex items-center justify-center w-1/6">
          <a href="https://www.agivant.com"> <img src={logo} alt="Company Logo" className="" /></a>
        </div>
        
        <div className="flex flex-col items-center justify-center w-1/4 md:w-1/6 sm:w-1/2">
          <div className="text-white font-normal text-xs my-2">Level up. Join us on LinkedIn!</div>
          <div className="w-2/3  justify-self-center">
            <a href="https://www.linkedin.com/company/agivant-tech/"> <img src={linkedIn} alt="LinkedIn Logo" className=""/></a>
          </div>
          
        </div>

      </div>
      <div>
         <hr className="flex justify-center items-center border-t border-2 border-white w-full mt-2" />
      </div>

         <div className="flex flex-row justify-between">
 
        <div className="flex flex-col items-start ">
          <div className="text-sm space-x-2 my-2 text-white">
            <a
              href="mailto:aiampdse@agivant.com?subject=Support%20Request&body=Hello%20team,"
              className="text-white"
            >
              Contact Us
            </a>   |
  
            <Link to="/profile" className="text-white">User Profile</Link> |
            <Link to="/faq" className="text-white">FAQs</Link>
          </div>
 
          <div className="text-white font-light text-sm mt-1">© Agivant Technologies 2024. All Rights Reserved.</div>
 
        </div>
      
    
    <div className="flex flex-col items-center justify-center w-1/4 md:w-1/6 sm:w-1/2">
      <div className="text-white text-sm font-normal my-2">Follow us on</div>
        
        <div className="flex flex-row justify-center gap-[10px] mt-1">
          <a className= "flex justify-center items-center text-[#2c3045] bg-white p-[6px] rounded-full text-[14px] no-underline" href="https://www.linkedin.com/company/agivant-tech/" target="_blank" rel="noreferrer">
            <FaLinkedin />
          </a>
          <a className= "flex justify-center items-center text-[#2c3045] bg-white p-[6px] rounded-full text-[14px] no-underline" href="https://twitter.com/AgivantTech" target="_blank" rel="noreferrer">
            <FaTwitter />
          </a>
          <a className= "flex justify-center items-center text-[#2c3045] bg-white p-[6px] rounded-full text-[14px] no-underline" href="https://www.youtube.com/@agivanttechnologies" target="_blank" rel="noreferrer">
            <FaYoutube />
          </a>
          <a className= "flex justify-center items-center text-[#2c3045] bg-white p-[6px] rounded-full text-[14px] no-underline" href="https://www.instagram.com/agivanttech/" target="_blank" rel="noreferrer">
            <FaInstagram />
          </a>
        </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
